import { cn } from "@/lib/utils";
import { useDocumentTitle } from "@/lib/useDocumentTitle";

interface PageHeaderProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
  eyebrow?: React.ReactNode;
}

export function PageHeader({ title, description, actions, className, eyebrow }: PageHeaderProps) {
  useDocumentTitle(typeof title === "string" ? title : "Admin");
  return (
    <header className={cn("flex flex-col gap-3 pb-6 sm:flex-row sm:items-end sm:justify-between", className)}>
      <div>
        {eyebrow && <p className="mb-1 text-xs font-semibold uppercase tracking-widest text-muted-foreground">{eyebrow}</p>}
        <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
        {description && <p className="mt-1 text-sm text-muted-foreground">{description}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </header>
  );
}
